// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--LYRAdGy7QZoBVps6","title":"title--PkC220ZRw1wMOblu","supportChat":"support-chat--GiRUGoYfn9YAfilk","phones":"phones--x4HUkFtvRXozNvx3"};